
<loader-overlay-component [show]="(isCallFromQRCode || isCallFromDirectURL) && !isAnnouncementPageVisible"></loader-overlay-component>
<div [ngClass]="{'displayNoneAll':((isCallFromQRCode || isCallFromDirectURL) && !isAnnouncementPageVisible)}">
<svg-definitions></svg-definitions> 
<app-header ></app-header>

<div class="mainBody">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
</div>